import React, { ReactNode } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";

import getMarkerShapeIcon from "@app/scene/map/utils/getMarkerShapeIcon";
import { getMarkerShapeDisplayName } from "@app/util/ui";

import styles from "./ShapeBadge.module.scss";

interface Props {
  label: ReactNode;
  shape: MarkerShape | undefined;
}

const ShapeBadge: React.FC<Props> = ({ label, shape }) => {
  const intl = useIntl();

  const icon = shape ? getMarkerShapeIcon(shape) : undefined;
  if (!icon || !shape) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Tooltip title={getMarkerShapeDisplayName(intl, shape)}>
        <FontAwesomeIcon className={styles.icon} icon={icon} />
      </Tooltip>
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default ShapeBadge;
